export default __webpack_public_path__ + "media/images/2-8e3eaa0ffd6abd554bd9e5f30684c8d0.jpg";